import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

// Création du contexte pour le graphique
const ChartContext = createContext();

// Fournisseur du contexte
export const ChartProvider = ({ children }) => {
  const [chartData, setChartData] = useState([]); // Stockage des données du graphique

  // Fonction pour mettre à jour les données du graphique uniquement si elles changent
  const updateChartData = useCallback((newData) => {
    // Si les nouvelles données sont différentes des données actuelles, on met à jour
    if (JSON.stringify(chartData) !== JSON.stringify(newData)) {
      setChartData(newData);
    }
  }, [chartData]);

  // Utilisation de useMemo pour mémoriser la valeur du contexte, afin de ne pas la recalculer à chaque render
  const contextValue = useMemo(() => ({
    chartData,
    setChartData: updateChartData, // Passer la fonction optimisée pour la mise à jour
  }), [chartData, updateChartData]);

  return (
    <ChartContext.Provider value={contextValue}>
      {children}
    </ChartContext.Provider>
  );
};

// Hook personnalisé pour accéder au contexte
export const useChart = () => {
  return useContext(ChartContext);
};
